
<ng-container *ngFor="let subject of subjects;let subjindex = index">
    <div class="UNFAPP-score-whitetbx crt-incrt-chrtbx" #accro>
        <div class="UNFAPP-score-whitetbx-hdr">
            <div class="row justify-content-between UNFAPP-header-row top-row">
                <div class="col-auto">
                    <h4 class="UNFAPP-score-subject-title subject-title">{{subject?.subjectname}}</h4>
                </div>
                <div class="col-auto"><button class="UNFAPP-accro-hdr-btn" (click)="accro.classList.toggle('expaned')"></button></div>
            </div>
            <div class="row justify-content-between UNFAPP-header-row bottom-row">
                <div class="col-auto">
                    <ng-container *ngTemplateOutlet="subjectAnalytics;context:{ subject:subject }"></ng-container>
                </div>
                <div class="col-auto">
                    <ng-container *ngTemplateOutlet="anwserTypeCount;context:{ subject:subject }"></ng-container>
                </div>
            </div>
        </div>
        <div class="UNFAPP-score-whitetbx-content">
            <ng-container *ngIf="subject?.papers?.length;else quelen">
                <ng-container *ngFor="let questions of subject?.papers;let papein =index">
                    <!-- {{subject?.subjectAnalytics|json}} -->
                    <div class="UNFAPP-score-whitetbx-paper-row">
                        <div class="row justify-content-between content-top-row">
                            <div class="col-auto">
                                <h4 class="UNFAPP-score-subject-title paper-title">Paper {{questions?.papernum}}</h4>
                            </div>
                            <div class="col-auto">
                                <ng-container *ngTemplateOutlet="subjectSectionButtons;context:{ subject:subject, subjindex:subjindex }"></ng-container>
                            </div>
                        </div>
                        <div class="row justify-content-between UNFAPP-score-mob-row UNFAPP-score-row-gap content-bottom-row">
                            <div class="col-xl-2 col-lg-2 col-auto first-col">
                                <ng-container *ngTemplateOutlet="subjectAnalytics;context:{ subject:questions }"></ng-container>
                            </div>
                            <div class="col-xl-8 col-lg-8 col-12 mid-col">
                                <div class="UNFAPP-score-qube-wrap">
                                    <ng-container *ngTemplateOutlet="questionbuttons;context:{ $implicit:questions.questions,subjindex:subjindex,papernum:papein}"></ng-container>  
                                </div>
                            </div>
                        
                            <div class="col-auto last-col">     
                                <ng-container *ngTemplateOutlet="anwserTypeCount;context:{ subject:questions }"></ng-container>
                            </div>
                        
                        </div> 
                    </div>
                </ng-container>
            </ng-container>

            <ng-template #quelen>
                <div class="row justify-content-between mb-4">
                    <div class="col-auto">
                        <h4 class="UNFAPP-score-subject-title">{{subject?.subjectname}}</h4>
                    </div>
                    <div class="col-auto">
                        <ng-container *ngTemplateOutlet="subjectSectionButtons;context:{ subject:subject, subjindex:subjindex }"></ng-container>
                    </div>
                </div>
                <div class="row justify-content-between UNFAPP-score-mob-row UNFAPP-score-row-gap">
                    <div class="col-xl-2 col-lg-2 col-auto first-col">
                        <ng-container *ngTemplateOutlet="subjectAnalytics;context:{ subject:subject }"></ng-container>
                    </div>
                    <div class="col-xl-8 col-lg-8 col-12 mid-col">
                
                        <div class="UNFAPP-score-qube-wrap">
                            <ng-container *ngTemplateOutlet="questionbuttons;context:{ $implicit:subject?.questions,subjindex:subjindex,papernum:-1}"></ng-container>
                        </div>
                    </div>
                
                    <div class="col-auto last-col">
                        <ng-container *ngTemplateOutlet="anwserTypeCount;context:{ subject:subject }"></ng-container>
                    </div>
                </div>
            </ng-template>
            
        </div>
    </div>
</ng-container>






















<!-- <br>
<br>
<br>
<br>
<br> -->

<!-- old code start -->
<!-- <div class="UNFAPP-score-whitetbx crt-incrt-chrtbx">
<ng-container *ngFor="let subject of subjects;let subjindex = index">
 
    <div class="row justify-content-between mb-4">
       <div class="col-auto"><h4 class="UNFAPP-score-subject-title">{{subject?.subjectname}}</h4></div> 
       <div class="col-auto">
        <ul class="UNFAPP-score-sctn-list">
            <li class="text-button " [ngClass]="{'active': subject?.selectedSection ==''  }" (click)="sectionFilter(subject?.subjectname,'',subjindex)">All</li>
            <ng-container *ngFor="let section of subject?.sections">
                <li class="text-button" [ngClass]="{'active': subject?.selectedSection ==  section?.name}"(click)="sectionFilter(subject?.subjectname,section?.name,subjindex)">
                    {{section?.name}} 
                </li>
            </ng-container>
        </ul>
        </div>
    </div>
    <div class="row justify-content-between UNFAPP-score-mob-row UNFAPP-score-row-gap">
        <div class="col-xl-2 col-lg-2 col-auto first-col">
            <div *ngIf="subject?.selectedSection ==''" class="UNFAPP-score-number"><span class="dark">{{subject?.subjectAnalytics?.totalScore}}</span>/{{subject?.subjectAnalytics?.outOfScore}}</div>
            <div *ngIf="subject?.selectedSection"  class="UNFAPP-score-number"><span class="dark">{{subject?.subjectAnalytics[subject?.selectedSection]?.totalScore||0}}</span>/ {{subject?.subjectAnalytics[subject?.selectedSection]?.outOfScore||0}}</div>
        </div>
        <div class="col-xl-8 col-lg-8 col-12 mid-col">

            <div class="UNFAPP-score-qube-wrap">
                <ng-container *ngIf="subject?.papers?.length;else quelen">
                    <ng-container *ngFor="let questions of subject?.papers;let papein =index">
                        <h3>paper-{{questions?.papernum}}</h3>
                        <ng-container
                            *ngTemplateOutlet="questionbuttons;context:{ $implicit:questions.questions,subjindex:subjindex,papernum:papein}"></ng-container>
                    </ng-container>
                </ng-container>
                <ng-template #quelen>
                    <ng-container
                        *ngTemplateOutlet="questionbuttons;context:{ $implicit:subject?.questions,subjindex:subjindex,papernum:-1}"></ng-container>
                </ng-template>
             
            </div>
        </div>

        <div class="col-auto last-col">
            <div class="d-flex flex-column UNFAPP-score-type">
            <div class="UNFAPP-score-with-type"><span class="qube correct"></span> {{subject?.subjectAnalytics?.totalCorrectQuestions+'/'+(subject?.selectedSection ==''? subject?.subjectAnalytics?.totalQuestions :(subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions))}}</div>
            <div class="UNFAPP-score-with-type"><span class="qube incorrect"></span>{{subject?.subjectAnalytics?.totalInCorrectQuestions+'/'+(subject?.selectedSection ==''? subject?.subjectAnalytics?.totalQuestions :(subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions))}}</div>
            <div class="UNFAPP-score-with-type"><span class="qube unattempted"></span>{{subject?.subjectAnalytics?.totalUnAttemptedQuestions+'/'+(subject?.selectedSection ==''? subject?.subjectAnalytics?.totalQuestions :(subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions))}}</div>
            </div>
        
        </div>

    </div>
</ng-container>
</div> -->
<!-- old code ended -->

<ng-template #questionbuttons let-questions let-subjindex="subjindex" let-papernum="papernum">
    <ng-container *ngFor="let question of questions;let i =index">
        <button class="UNFAPP-score-qube" *ngIf="question?.showQuestion" (click)="moveToViewSolutionPage(subjindex,i,papernum)"
            (mouseover)="showtoolTip(question,subjindex,i)" (mouseout)="showTooltipindex =-1"
            [ngClass]="{'correct':question?.iscorrect=='Y','incorrect':question?.iscorrect=='N','unattempted':question?.iscorrect=='NA','markedreview':question?.ismarkedforreview}">
            
            {{papernum ==-1? ((subjects[subjindex-1]?.questions?.length)*subjindex+ i+1): (subjects[subjindex-1]?.papers[papernum]?.questions?.length)*subjindex+ i+1}}
            <!-- <div *ngIf="showTooltipindex == i && subjindex == selected_subjectTooltipindex" [ngStyle]="toolTipStyle">
                Time- <span class="font-weight-bold ml-1"> {{timeinSec}} </span> </div> -->
        </button>
    </ng-container>
</ng-template>
 
<!-- <div class="row justify-content-between">
    <button>correct Answer</button>
    <button>incorrect Answer</button>
    <button>Unattempted </button>
    <button>Marked for Review </button>

</div> -->
<ng-template #subjectAnalytics let-subject="subject">
    <div *ngIf="!subject?.selectedSection" class="UNFAPP-score-number"><span
            class="dark"> {{subject?.subjectAnalytics?.totalScore||0}}</span>/{{subject?.subjectAnalytics?.outOfScore||0}}
    </div>
    <div *ngIf="subject?.selectedSection" class="UNFAPP-score-number"><span
            class="dark">{{subject?.subjectAnalytics[subject?.selectedSection]?.totalScore||0}}</span>/
        {{subject?.subjectAnalytics[subject?.selectedSection]?.outOfScore||0}}</div>
</ng-template>


<ng-template #subjectSectionButtons let-subject="subject" let-subjindex="subjindex">
    <ul class="UNFAPP-score-sctn-list">
        <li class="text-button " [ngClass]="{'active': subject?.selectedSection ==''  }"
            (click)="sectionFilter(subject?.subjectname,'',subjindex)">All</li>
        <ng-container *ngFor="let section of subject?.sections">
            <li class="text-button" [ngClass]="{'active': subject?.selectedSection ==  section?.name}"
                (click)="sectionFilter(subject?.subjectname,section?.name,subjindex)">
                {{section?.name}}
            </li>
        </ng-container>
    </ul>
</ng-template>


<ng-template #anwserTypeCount let-subject="subject">
    <div class="d-flex flex-column UNFAPP-score-type">
        <div class="UNFAPP-score-with-type"><span class="qube correct"></span>
            {{(subject?.subjectAnalytics?.totalCorrectQuestions||0)+'/'+(subject?.selectedSection ?
            (subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions||0)            
            :subject?.subjectAnalytics?.totalQuestions||0)}}</div>
        <div class="UNFAPP-score-with-type"><span
                class="qube incorrect"></span>{{(subject?.subjectAnalytics?.totalInCorrectQuestions||0)+'/'+(subject?.selectedSection 
                ? (subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions||0)
            :subject?.subjectAnalytics?.totalQuestions||0)}}</div>
        <div class="UNFAPP-score-with-type"><span
                class="qube unattempted"></span>{{(subject?.subjectAnalytics?.totalUnAttemptedQuestions||0)+'/'+(subject?.selectedSection
                ? (subject?.subjectAnalytics[subject?.selectedSection]?.totalQuestions||0)
                :subject?.subjectAnalytics?.totalQuestions||0)}}</div>
    </div>
</ng-template>